<div class="main-layout">
	<vis-loading-spinner size="m" [label]="loadingMessage()"></vis-loading-spinner>
</div>
